<template>
  <section class="phero">
    <div class="wrap">
      <span class="eyebrow"><span class="dot"></span>Contact</span>
      <h1 id="contact-us">Contact Us</h1>
      <p class="lede">We would love to hear from you! Please fill out this form and we will get in touch with you shortly.</p>
    </div>
  </section>
  <section class="block">
    <div class="wrap split">
      <div class="stack" style="gap:22px">
        <span class="eyebrow"><span class="dot"></span>Write to us</span>
        <div class="payrow"><div><div class="lbl">Email</div><div class="val">admin@thedreaminc.org</div></div></div>
      </div>
      <form class="contact-form app-page" @submit.prevent="sendMessage()">
        <label class="contact-field">
          <span class="contact-field__label">Name</span>
          <input v-model="form.name" class="app-input contact-field__input" type="text" name="name" required>
        </label>
        <label class="contact-field">
          <span class="contact-field__label">Email</span>
          <input v-model="form.email" class="app-input contact-field__input" type="text" name="email" required>
        </label>
        <label class="contact-field">
          <span class="contact-field__label">Message</span>
          <textarea v-model="form.message" class="app-input contact-field__input contact-field__textarea" rows="8" name="message" required></textarea>
        </label>
        <button class="btn btn-primary" type="submit">Send Message <span class="arr" aria-hidden="true">&rarr;</span></button>
      </form>
    </div>
  </section>
</template>

<script>

import {sendAdminEmail} from "@/api/email";

export default {
  name: 'MeetTheTeam',
	data() {
    return {
      form: {
				name: '',
				email: '',
				message: '',
			},
		}
	},
  components: {
  },
  mounted() {
	window.scrollTo({top: 0, behavior: 'smooth'});
  },
  methods: {
		sendMessage() {
			//send message here
      sendAdminEmail(this.form).then((response) => {

        alert("Message Sent");
        this.form.name = '';
        this.form.email = '';
        this.form.message = '';
        console.log(response)
      }).catch((error) => {
        console.error(error);
      });
		}
  }
}
</script>

<style scoped lang="scss">
.contact-form {
  display: flex;
  flex-direction: column;
  gap: 18px;

  .btn {
    align-self: flex-start;
  }
}

.contact-field {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__label {
    color: var(--ink-2);
    font-size: 13px;
    font-weight: 600;
    letter-spacing: .12em;
    text-transform: uppercase;
  }

  &__input {
    padding: 12px 14px;
    width: 100%;
  }

  &__textarea {
    resize: vertical;
  }
}
</style>
